export const TAG__PERMISSIONS = {
  GOALS_STRUCTURES: {
    VIEW: {
      permissionGroupName: 'Przeglądanie struktur celów',
      NONE: {
        dbName: 'TAG__GOALS_STRUCTURES__VIEW__NONE',
        name: 'Brak uprawnień',
        description: 'Brak dostępu do struktur celów w systemie.'
      },
      RELATED_TO_GOALS: {
        dbName: 'TAG__GOALS_STRUCTURES__VIEW__RELATED_TO_GOALS',
        name: 'Struktury powiązane z celami użytkownika',
        description:
          'Widok grafów prerekwizytów i drzew umiejętności powiązanych z celami użytkownika, włącznie z ich węzłami i krawędziami.'
      },
      ALL: {
        dbName: 'TAG__GOALS_STRUCTURES__VIEW__ALL',
        name: 'Wszystkie struktury',
        description:
          'Widok wszystkich grafów prerekwizytów i drzew umiejętności, włącznie z ich węzłami i krawędziami.'
      }
    },
    MANAGE: {
      permissionGroupName: 'Zarządzanie strukturami celów',
      NONE: {
        dbName: 'TAG__GOALS_STRUCTURES__MANAGE__NONE',
        name: 'Brak uprawnień',
        description: 'Brak możliwości zarządzania strukturami celów w systemie.'
      },
      RELATED_TO_GOALS: {
        dbName: 'TAG__GOALS_STRUCTURES__MANAGE__RELATED_TO_GOALS',
        name: 'Zarządzanie strukturami powiązanymi z celami użytkownika',
        description:
          'Możliwość: edycji celów powiązanych z użytkownikiem, dodawania/edycji/archiwizacji tagów powiązanych z celami użytkownika, dodawania/archiwizacji węzłów i krawędzi w drzewach umiejętności i grafach prerekwizytów powiązanych z celami użytkownika.'
      },
      ALL: {
        dbName: 'TAG__GOALS_STRUCTURES__MANAGE__ALL',
        name: 'Zarządzanie wszystkimi strukturami',
        description:
          'Możliwość dodawania/edycji/archiwizacji wszystkich celów, dodawania/edycji/archiwizacji tagów, dodawania/edytowania/archiwizowania drzew umiejętności i grafów prerekwizytów.'
      }
    }
  },
  SKILL_TREE: {
    VIEW: {
      permissionGroupName: 'Podgląd drzewa rozwoju',
      NONE: {
        dbName: 'TAG__SKILL_TREE__VIEW__NONE',
        name: 'Brak uprawnień',
        description: 'Brak możliwości podglądu drzewa rozwoju.'
      },
      OWNED: {
        dbName: 'TAG__SKILL_TREE__VIEW__OWNED',
        name: 'Własne drzewo rozwoju',
        description: 'Możliwość podglądu własnego drzewa rozwoju.'
      }
    }
    // TO-DO: Add other permissions for skill-tree as viewing my students skill-trees etc.
  }
} as const
